export const mockData = {
  seq: 1,
  question: '안녕하세요 영상제작 봉사신청을 하고싶은데 로그인이 안돼요 답변부탁드립니다 감사합니다',
  answer:
    '정토행자 제2차 만일결사 중 제1차 천일결사 제5차 백일기도\n103일째 기도 🙏 명심문: “우리는 모자이크 붓다입니다.”\n[개인약속] 613 만인대법회 참석하기 & 행복학교 1명이상 인연맺기',
  regDate: '2021-09-01',
  updateDate: '2021-09-01',
  questionType: '봉사내용',
  status: '답변완료',
};
